import React, { useState, useEffect } from 'react';
import axios from 'axios';
import API_URL from '../config';

function AddStaffModal({ onClose, onSuccess }) {
  const [name, setName] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [phone, setPhone] = useState('');
  const [role, setRole] = useState('');
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchRoles();
  }, []);

  const fetchRoles = async () => {
    try {
      const res = await axios.get(`${API_URL}/get-roles`);
      const staffRoles = res.data.filter(r => r.name !== 'customer');
      setRoles(staffRoles);
    } catch (err) {
      console.error(err);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API_URL}/add-staff`, {
        name,
        username,
        password_hash: password,
        phone,
        role
      });
      onSuccess();
      onClose();
    } catch (err) {
      alert('Error adding staff: ' + (err.response?.data?.error || err.message));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal">
        <h2>Add New Staff</h2>
        <form onSubmit={handleSubmit}>
          <input type="text" placeholder="Full Name" value={name} onChange={(e) => setName(e.target.value)} required />
          <input type="text" placeholder="Username" value={username} onChange={(e) => setUsername(e.target.value)} required />
          <input type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} required />
          <input type="tel" placeholder="Phone Number" value={phone} onChange={(e) => setPhone(e.target.value)} />
          <select value={role} onChange={(e) => setRole(e.target.value)} required>
            <option value="">Select Role</option>
            {roles.map(r => <option key={r.id} value={r.name}>{r.name.replace('_', ' ').toUpperCase()}</option>)}
          </select>
          <div className="modal-buttons">
            <button type="button" onClick={onClose}>Cancel</button>
            <button type="submit" disabled={loading}>{loading ? 'Adding...' : 'Add Staff'}</button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddStaffModal;